import { get } from '@/utils/request'
/**
 * 所有商品
 * @param {Object} data
 */
// 获取筛选集合
export function getGoodsDicts() {
  return get('/miniapps/filterItem/selectCommodityFilterItem')
}
//获取品牌集合
export function getBrandsLists(data) {
  return get('/miniapps/filterItem/selectBrandFilterItem',data)
}